// import { ReactComponent as Logo } from 'assets/icons/BYOD Logo_Tagling_Reverse.svg';
import img from 'assets/new_icons/new_mabel_logo_login-preview.png';



import { FC } from 'react';

// CSS modules
import AuthLayouts from './authLayout.module.scss';

interface IAuthLayout {
	children: JSX.Element;
}

export const AuthLayout: FC<IAuthLayout> = ({ children }) => {
	const currentYear = new Date().getFullYear();
	
	return (
		<div className={AuthLayouts.container}>
			<div className={AuthLayouts.content}>
				<div className='logoContainer'>
					<img src={img} alt="Logo" />
				</div>
				<div>{children}</div>
			</div>
			<div className={AuthLayouts.footer}>
				© {currentYear} BYOD, Inc. All rights reserved.
			</div>
		</div>
	);
};
